import {
  ENABLE_DISTANCE_READOUT,
  DISABLE_DISTANCE_READOUT
} from '../common/actionTypes';

const defaultState = {
  distance: null
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case ENABLE_DISTANCE_READOUT:
      return {
        distance: action.distance
      };

    case DISABLE_DISTANCE_READOUT:
      return {
        distance: null
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./map/reducers/distanceReadoutReducer.js